export default "__VITE_ASSET__BWS3jnvL__"